import type { ComponentProps } from "react";
import { cnBase } from "tailwind-variants";

export function Success({
	pending,
	className,
	...props
}: ComponentProps<"svg"> & { pending?: boolean }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="none"
			data-pending={pending || undefined}
			className={cnBase("group/success", className)}
			{...props}
		>
			<path
				fill="currentColor"
				className="group-data-pending/success:opacity-0 group-data-pending/success:[stroke-dasharray:0_100%] [stroke-dasharray:100%_0] transition-[stroke-dasharray,opacity] opacity-100"
				d="M12.123 7.432a.75.75 0 0 1 1.258.816l-2.598 4.008a1.35 1.35 0 0 1-2.076.233l-1.984-1.936A.75.75 0 1 1 7.77 9.48l1.417 1.38a.5.5 0 0 0 .768-.085l2.168-3.343Z"
			/>
			<circle
				cx={10}
				cy={10}
				r={7}
				stroke="currentColor"
				strokeWidth={1.5}
				className="transition-[stroke-dasharray,color] [stroke-dasharray:100%_0] group-data-pending/success:[stroke-dasharray:3_3]"
			/>
		</svg>
	);
}
